import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CTAButton } from '../CTAButton';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfter() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-87" data-mp="26mmawj50yzj7">
      <div className="mx-auto max-w-5xl" data-id="element-88" data-mp="22lsnrrzepord">
        <SectionHeading eyebrow="Before & after" title="Stop improvising when a patient has abnormal kidney function" subtitle="Start making decisions as if you had a clear renal decision pathway beside you during every consultation." data-id="element-89" data-mp="22iy3c0ge83xy" />

        <div className="mt-9 grid grid-cols-1 gap-4 sm:mt-12 lg:grid-cols-2 lg:gap-6" data-id="element-90" data-mp="2q8siioo6q4ld">
          <article className="rounded-3xl border border-navy-100 bg-white p-5 sm:p-7" data-id="element-91" data-mp="2lah5y66i9fzg">
            <div className="flex items-center gap-2.5" data-id="element-92" data-mp="1ew81p07yibdv">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-navy-100" data-id="element-93" data-mp="19w3n5fqlzqqa">
                <XIcon className="h-4 w-4 text-navy-500" aria-hidden="true" data-id="element-94" data-mp="175cmq44uifjl" />
              </span>
              <h3 className="font-display text-xl font-bold text-navy-500 sm:text-2xl" data-id="element-95" data-mp="1c4gucqc4g57t">Before</h3>
            </div>
            <p className="mt-3 text-[15px] font-bold leading-snug text-navy-900 sm:text-base" data-id="element-96" data-mp="y57fpv3kdj5y">
              You make decisions with uncertainty
            </p>
            <ul className="mt-4 space-y-3" data-id="element-97" data-mp="135vi1cx8tmfh">
              {beforeItems.slice(1).map(item => <li key={item} className="flex gap-2.5" data-id="element-98" data-mp="ocrwyvkg0qk0">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy-300" aria-hidden="true" data-id="element-99" data-mp="t6mqeqpuojwa" />
                  <span className="text-[14px] font-medium leading-relaxed text-navy-600 sm:text-[15px]" data-id="element-100" data-mp="fezkdz63vx0b">
                    {item}
                  </span>
                </li>)}
            </ul>
            <p className="mt-5 rounded-2xl bg-navy-50 px-4 py-3.5 text-[14px] font-medium italic leading-relaxed text-navy-600 sm:text-[15px]" data-id="element-101" data-mp="5h1xpg3wa89t">
              You leave the office thinking: “I hope I made the right decision.”
            </p>
          </article>

          <article className="rounded-3xl border-2 border-brick-200 bg-white p-5 shadow-[0_20px_50px_-30px_rgba(8,32,60,0.5)] sm:p-7" data-id="element-102" data-mp="27dsumwct33tw">
            <div className="flex items-center gap-2.5" data-id="element-103" data-mp="23d0hvt4q6gsv">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-brick-600" data-id="element-104" data-mp="1ycur0f6a4ybu">
                <CheckIcon className="h-4 w-4 text-white" aria-hidden="true" data-id="element-105" data-mp="2v354lyfyjfx9" />
              </span>
              <h3 className="font-display text-xl font-bold text-brick-700 sm:text-2xl" data-id="element-106" data-mp="2r1jq68nrytky">
                With Kidney Disease Route™
              </h3>
            </div>
            <p className="mt-3 text-[15px] font-bold leading-snug text-navy-900 sm:text-base" data-id="element-107" data-mp="2m0m2xhnwr9cl">
              You make decisions with a clear clinical route
            </p>
            <ul className="mt-4 space-y-3" data-id="element-108" data-mp="1ao32pyvt904c">
              {afterItems.map(item => <li key={item} className="flex gap-2.5" data-id="element-109" data-mp="15n5m3qqg8e4y">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brick-600" aria-hidden="true" data-id="element-110" data-mp="15qjm4sbn4b98" />
                  <span className="text-[14px] font-medium leading-relaxed text-navy-700 sm:text-[15px]" data-id="element-111" data-mp="10jcw3fpgp7ts">
                    {item}
                  </span>
                </li>)}
            </ul>
            <p className="mt-5 rounded-2xl bg-brick-50 px-4 py-3.5 text-[14px] font-semibold leading-relaxed text-brick-800 sm:text-[15px]" data-id="element-112" data-mp="1a8wgwqwqjbra">
              The result is simple: your patient feels confident. And so do you.
            </p>
          </article>
        </div>

        <div className="mt-10 sm:mt-12" data-id="element-113" data-mp="1jbxl2m21issb">
          <CTAButton label="I want to make confident renal decisions" subline="300+ clinical pages • 6 premium volumes • 5 bonuses • 100% digital" data-id="element-114" data-mp="1o8ecpq8g7pa5" />
        </div>
      </div>
    </section>;
}